import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {ROOT_URL} from "../../../config/url";
import {
  getErrorMessageByKey,
  Input,
  isValidateNullText,
  jsonFormatText,
  Modal,
  Select,
  useList, useLocalStorage,
  useNotification,
  useObject,
} from "@vokymlak/kabinet-ui";

function ModalPriceTagPrint(props) {
  // ----------------------------------------------------------------------------------------------------
  const [localSettings, setLocalSettings] = useLocalStorage(
    "printer",
    {
      printerUuid: null,
    }
  );
  const [printerUuid, setPrinterUuid] = useState(
    localSettings.printerUuid || null
  );
  useEffect(() => {
    setLocalSettings({
      printerUuid,
    });
  }, [
    printerUuid,
  ]);
  // ----------------------------------------------------------------------------------------------------

  const inputPrinter = useRef(null);
  const inputNumberCopies = useRef(null);

  const {notification} = useNotification();

  const {
    list: [printers],
  } = useList({
    apiUrl: "/api/printers/list",
    rootUrl: ROOT_URL,
  });

  const {
    object: [nomenclature],
  } = useObject({
    apiUrl: "/api/nomenclature/" + props.object.uuid,
    rootUrl: ROOT_URL,
    callbackError: () => {
      props.handleClose();
    },
  });

  const changeDownloadXLSX = () => {
    axios
      .get("/api/nomenclature/" + props.object.uuid + "/export/print/price/xlsx", {
        responseType: "arraybuffer",
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "№" + props.object.id + (!!props.object.name && '_' + props.object.name) + ".xlsx"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changeDownloadPDF = () => {
    axios
      .get("/api/nomenclature/" + props.object.uuid + "/export/print/price/pdf", {
        responseType: "arraybuffer",
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "№" + props.object.id + (!!props.object.name && '_' + props.object.name) + ".pdf"
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const changePrint = () => {
    const numberCopies = jsonFormatText(inputNumberCopies.current.value);
    const printerUuid = jsonFormatText(inputPrinter.current.value);

    if (isValidateNullText(numberCopies) || Number(numberCopies) < 1) {
      notification("Заполните все обязательные поля", "red");
      return;
    }

    if (isValidateNullText(printerUuid) || printerUuid === 'null') {
      notification("Заполните все обязательные поля", "red");
      return;
    }

    const jsonData = JSON.stringify({
      number_copies: Number(numberCopies),
      printer: !!printerUuid && printerUuid.length > 0 && printerUuid !== 'null' ? {
        uuid: printerUuid,
      } : null,
    });

    axios
      .post("/api/nomenclature/" + props.object.uuid + "/price/print", jsonData, {
        withCredentials: false,
        baseURL: ROOT_URL,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("tokenSession"),
        },
      })
      .then(() => {
        props.successfulRequest();
        notification("Отправлено на печать", "blue");
        props.handleClose();
      })
      .catch((error) => {
        notification(getErrorMessageByKey(error.response.data.error), "red");
      });
  };

  const getPrinterSelectOptions = (list) => {
    const options = [
      // {
      //   value: "null",
      //   title: "Не выбран",
      // },
    ];

    list.map((item) => {
      const option = {
        value: item.uuid,
        title: item.name,
      };

      options.push(option);
    });

    return options;
  };

  return (
    !!nomenclature && (
      <>
        <Modal handleClose={() => props.handleClose()}>
          <div className="Form">
            <div className="Form__title">
              Ценник: {nomenclature.name}
              <div className="Text__signature">Печать</div>
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_blue"
                      onClick={(event) => changeDownloadXLSX()}>
                Скачать XLSX
              </button>
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_blue"
                      onClick={(event) => changeDownloadPDF()}>
                Скачать PDF
              </button>
            </div>

            <div className="Form__field" style={{
              marginTop: 16
            }}>
              <Select
                isFixed={true}
                options={getPrinterSelectOptions(printers)}
                label="Принтер"
                reference={inputPrinter}
                onChange={(event) => setPrinterUuid(event.target.value)}
                value={!!printerUuid && printerUuid}
              />
            </div>

            <div className="Form__field Form__field_last">
              <Input
                reference={inputNumberCopies}
                type={'number'}
                label="Количество копий *"
                value={1}
              />
            </div>

            <div className="Form__actions Form__actions_center">
              <button className="Action__button Action__button_all Action__button_blue"
                      onClick={(event) => changePrint()}>
                Печать
              </button>
            </div>
          </div>
        </Modal>
      </>
    )
  );
}

export default ModalPriceTagPrint;
